import { apiUrl, authHeaders } from "./httpAuth";

export async function fetchCalendarioItems() {
    const res = await fetch(apiUrl("api/calendario/items"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchCalendarioDetalle(tipo, id) {
    const res = await fetch(apiUrl(`api/calendario/${String(tipo).toLowerCase()}/${id}`), {
        headers: authHeaders(),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}
